import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../icons/icon.component';

/**
 * Global empty-state placeholder.
 *
 * Covers the common "no data yet" block: an icon, a title, an optional
 * description, and an optional action (button/link/dropdown) projected in.
 *
 * @example
 * <app-empty-state icon="users" title="No Patients Found" description="Add your first patient to get started">
 *   <a class="btn btn-primary btn-sm" routerLink="/patient/add-patient">
 *     <app-icon name="add"></app-icon> Add Patient
 *   </a>
 * </app-empty-state>
 *
 * With no projected content, only the icon/title/description render.
 */
@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.css',
})
export class EmptyStateComponent {
  @Input() icon = 'inbox';
  @Input() iconSize = 48;
  @Input() title = 'No data found';
  @Input() description = '';
  /** Compact reduces vertical padding, for use inside cards/panels rather than full page sections. */
  @Input() compact = false;
}
